import React from 'react';
import PropTypes from 'prop-types';

import NotificationSvg from './notification.svg';

export const NotificationIcon = (props) => <NotificationSvg {...props} />;

NotificationIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  className: PropTypes.string,
};
